import { X } from "lucide-react";
import { Icon } from "../controls/icon";

/**
 * Pieces every overlay shares. Kept out of `index.ts`: a screen builds its
 * layers from the wrappers, not from these.
 */

/** A2's `IconButton`: a 48 px round surface button, the touch-target floor. */
export const ICON_BUTTON =
  "a-press grid size-12 shrink-0 place-items-center rounded-full bg-surface text-ink shadow-card";

/** A2's pill buttons: 56 px for the primary action, 48 px for the quiet one. */
export const PRIMARY_BUTTON =
  "a-press a-primary flex h-14 min-w-0 flex-1 items-center justify-center gap-2 rounded-full px-5 font-bold text-lg disabled:cursor-not-allowed disabled:opacity-40";
export const DANGER_BUTTON =
  "a-press flex h-14 min-w-0 flex-1 items-center justify-center gap-2 rounded-full bg-danger px-5 font-bold text-lg text-on-danger disabled:cursor-not-allowed disabled:opacity-40";
export const QUIET_BUTTON =
  "a-press flex h-14 shrink-0 items-center justify-center rounded-full bg-surface-2 px-6 font-semibold text-base text-ink";

/**
 * The scrim under a modal layer, left of the docked coach on desktop
 * (`--coach-dock`, D04). Base UI's `data-starting-style` / `data-ending-style`
 * drive the fade; the reduced-motion kill switch (T05) zeroes it.
 */
export const SCRIM =
  "fixed inset-0 bg-scrim transition-opacity duration-200 data-ending-style:opacity-0 data-starting-style:opacity-0 lg:right-[var(--coach-dock,0px)]";

export function CloseGlyph() {
  return <Icon icon={X} />;
}
